export default "__VITE_ASSET__BIseJzm___"